import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {AuthService} from "../../../shared/services/auth.service";
import {NgIf} from "@angular/common";

@Component({
  selector: 'vex-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatIconModule, NgIf]
})
export class FooterComponent implements OnInit, OnDestroy {
  currentYear: any;
user : any
  constructor(
    private authService: AuthService,
  ) {
    this.authService.self().subscribe(data => {
      if (data && data.id) {
        this.user = data;
      } });
  }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }

  ngOnDestroy(): void {
  }

  openUrl(url: any) {
    window.open(url, '_blank');
  }
}
